export default {
  shallowEquals: () => {
    return false;
  }
};
